/**
 * Optimizer Control Center — stats cards
 * For Media Devoted | Created By Ciro Autiero
 */

import type { FC } from 'react';
import { AlertTriangle, Gauge, PauseCircle, PlayCircle } from 'lucide-react';

import { Card, CardContent } from '@/components/ui';
import type { OptimizerStats } from '@/features/optimizer-center/optimizer-center.types';

const CARDS = [
  { key: 'total', label: 'Total configs', icon: Gauge, tone: 'text-foreground', chip: 'bg-muted text-muted-foreground' },
  { key: 'auto', label: 'Auto-run active', icon: PlayCircle, tone: 'text-success', chip: 'bg-success/10 text-success' },
  { key: 'paused', label: 'Paused', icon: PauseCircle, tone: 'text-warning', chip: 'bg-warning/10 text-warning' },
  { key: 'errors', label: 'Errors', icon: AlertTriangle, tone: 'text-destructive', chip: 'bg-destructive/10 text-destructive' },
] as const;

export const OptimizerStatsCards: FC<{ stats: OptimizerStats }> = ({ stats }) => (
  <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
    {CARDS.map(({ key, label, icon: Icon, tone, chip }) => (
      <Card key={key} className="transition-shadow hover:shadow-md">
        <CardContent className="flex items-center gap-4 p-5">
          <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-xl ${chip}`}>
            <Icon className="h-5 w-5" />
          </span>
          <div className="min-w-0">
            <p className="text-xs font-medium uppercase tracking-wide text-muted-foreground">
              {label}
            </p>
            <p className={`text-2xl font-bold tabular-nums leading-tight ${tone}`}>
              {stats[key]}
            </p>
          </div>
        </CardContent>
      </Card>
    ))}
  </div>
);
